/**
* @function HTMLElement.prototype.swipe　HTML要素のスワイプを検知する
*/
if(!HTMLElement.prototype.swipe){
  Object.defineProperty(HTMLElement.prototype, "swipe", {
    configurable: true,
    enumerable: false,
    writable: true,
    /**
    * @string direction  スワイプの方向(left, right, up, down)
    * @function callback  スワイプイベント時に実行するコールバック関数
    * @int sensitivity  スワイプの感度。値が大きいほど小さい動きで発火する。デフォルトは5 (画面サイズ/5のスワイプで発火)
    */
    value: function(direction,callback,sensitivity) {
      const self = this;
      const sens =  Object.prototype.toString.call(sensitivity)!=='[object Number]' || sensitivity <= 0 ? 5 : sensitivity;
      switch(direction){
        case 'left':
        self.addEventListener('touchstart', function (event) {
          self.removeEventListener("touchstart",null,false); //2回目以降触れただけで発火しないよう、イベントリスナを解除
          var position = event.changedTouches[0].pageX;
          self.addEventListener('touchend', function (event) {
            self.removeEventListener("touchend",null,false);
            if (event.changedTouches[0].pageX < position - screen.width / sens){
              callback(self);
            }
            position = 0;
          });
        },false);
        break;
        case 'right':
        self.addEventListener('touchstart', function (event) {
          self.removeEventListener("touchstart",null,false);
          var position = event.changedTouches[0].pageX;
          self.addEventListener('touchend', function (event) {
            self.removeEventListener("touchend",null,false);
            if(event.changedTouches[0].pageX > position + screen.width / sens){
              callback(self);
            }
            position = screen.width;
          });
        },false);
        break;
        case 'up':
        self.addEventListener('touchstart', function (event) {
          self.removeEventListener("touchstart",null,false);
          var position = event.changedTouches[0].pageY;
          self.addEventListener('touchend', function (event) {
            self.removeEventListener("touchend",null,false);
            if(event.changedTouches[0].pageY < position - screen.height / sens){
              callback(self);
            }
            position = 0;
          });
        },false);
        break;
        case 'down':
        self.addEventListener('touchstart', function (event) {
          self.removeEventListener("touchstart",null,false);
          var position = event.changedTouches[0].pageY;
          self.addEventListener('touchend', function (event) {
            self.removeEventListener("touchend",null,false);
            if(event.changedTouches[0].pageY > position + screen.height / sens){
              callback(self);
            }
            position = screen.height;
          });
        },false);
        break;
      }
    }
  });
}

import isMobile from './is-mobile.js';

$(".slidemenu-next").on("click", function(){
  $(".slidemenu-item").removeClass("is-current");
  $(this).next(".slidemenu-item").addClass("is-open is-current");
  $(this).closest(".slidemenu-item").removeClass("is-open is-current");
  $("body").addClass("slidemenu-open");
  var i = $(this).closest(".slidemenu-item").length;
  if(i > 0) {
    $(this).closest(".slidemenu-item").addClass("is-stamp");
    $(this).next(".slidemenu-item").addClass("is-next");
  }
  // $(this).closest(".fullScreenMenu-inner").addClass("is-out");
  // $(this).closest(".is-children").addClass("is-out");
})
$(".slidemenu-back").on("click", function(){
  var that = $(this);
  if($(this).closest(".slidemenu-item").parent().closest(".slidemenu-item").length == 0) {
    $("body").removeClass("slidemenu-open");
  }
  // $(this).closest(".slidemenu-item.is-open").addClass("is-current");
  $(this).closest(".slidemenu-item").parent().closest(".slidemenu-item").removeClass("is-stamp").addClass("is-open is-current is-aaaa");
  // console.log($(this).closest(".slidemenu-item").parent().closest(".slidemenu-item").removeClass("is-stamp").length);
  setTimeout(function() {
    that.closest(".slidemenu-item").removeClass("is-open");
    // that.closest(".slidemenu-item").hide();
    that.closest(".slidemenu-item").parent().closest(".slidemenu-item").removeClass("is-aaaa");
  }, 300);
})

// $('.slidemenu-item').each(function(){
//   var that = $(this);
//   this.swipe('right',function(dom){
//     $("body").removeClass("slidemenu-open");
//     $(".slidemenu-item.is-current").removeClass("is-open is-current");
//     setTimeout(function() {
//       that.closest(".slidemenu-item.is-open").addClass("is-current");
//     }, 100);
//   },5);  //<-- 画面サイズ/10の動作で発火
// });

//グローバルナビ メガメニュー スマホで親をタップしてもリンクしない
$('.slidemenu-content').on("click", function(e){
  if(isMobile(1194)){
    return ! $(e.target).closest("a").is(".slidemenu-next")
  }
})
